export const environment = {
  production: true,
  gasUrl:"https://simtools.edwardsvacuum.com/pumpCalcWeb/api/gases?format=json",
  jobsUrl:"https://simtools.edwardsvacuum.com/pumpCalcWeb/api/calculations",
  apiRootURL:"https://simtools.edwardsvacuum.com/pumpCalcWeb/api/",
  userURL: 'https://simtools.edwardsvacuum.com/pumpCalcWeb/api/user',
  unitsURL: 'https://simtools.edwardsvacuum.com/pumpCalcWeb/api/unitSetting',

  pumpSetsURL: 'https://simtools.edwardsvacuum.com/pumpCalcWeb/api/pumpsets?format=json',
  pumpSetDetailsURL:'https://simtools.edwardsvacuum.com/pumpCalcWeb/api/pumpsets/<id>/details?format=json',
  boostersURL:'https://simtools.edwardsvacuum.com/pumpCalcWeb/api/boosters?format=json',
  boosterDetailsURL:'https://simtools.edwardsvacuum.com/pumpCalcWeb/api/boosters/<id>/details?format=json',
  drivesURL:'https://simtools.edwardsvacuum.com/pumpCalcWeb/api/drives?format=json',
  backingPumpsURL:'https://simtools.edwardsvacuum.com/pumpCalcWeb/api/steadyPumps?format=json',
  backingPumpDetailsURL:'https://simtools.edwardsvacuum.com/pumpCalcWeb/api/steadyPumps/<id>/details?format=json',

  customPumpSetsURLForUser:"https://simtools.edwardsvacuum.com/pumpCalcWeb/api/customised/pumpsets/user/<id>?format=json",
  customPumpSetsURL:"https://simtools.edwardsvacuum.com/pumpCalcWeb/api/customised/pumpsets?format=json",
  customPumpSetDetailsURL:"https://simtools.edwardsvacuum.com/pumpCalcWeb/api/customised/pumpsets/<id>/details?format=json",
  customBoosterDetailsURL:"https://simtools.edwardsvacuum.com/pumpCalcWeb/api/customised/boosters/<id>/details?format=json",

  shareUrl:"https://simtools.edwardsvacuum.com/builder",

  //msal
  redirectUrl:"https://simtools.edwardsvacuum.com/builder",
  clientId: '756e3656-80cc-4c5a-ab25-ced6c6fe7d0f',
  authority: 'https://login.microsoftonline.com/43e4b026-d1f2-45e6-a6de-8abec322554a/',
  preview:false
};
